import * as React from 'react';
export const IcJioDotExclude = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#ic_jio_dot_exclude_svg__clip0_7826_127526)'>
      <path
        d='M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12 12-5.372 12-12S18.627 0 12 0zM9.68 12.693c0 2.568-1.23 3.742-3.564 3.742-1.92 0-2.955-.677-2.955-1.781 0-1.023.87-1.437.91-1.382.429.525.967.815 1.63.815.843 0 1.202-.373 1.202-1.436v-4.13c0-.855.414-1.284 1.173-1.284h.4c.788 0 1.202.429 1.202 1.285l.001 4.17zm3.601 2.333c0 .953-.483 1.285-1.16 1.285h-.277c-.718 0-1.215-.304-1.215-1.285v-4.418c0-.968.511-1.285 1.187-1.285h.277c.718 0 1.187.29 1.187 1.285l.001 4.418zm-1.298-6.407c-.883 0-1.436-.484-1.436-1.257 0-.76.539-1.243 1.395-1.243.884 0 1.436.47 1.436 1.243 0 .774-.538 1.257-1.395 1.257zm5.753 7.816c-2.279 0-3.728-1.409-3.728-3.605 0-2.14 1.505-3.576 3.77-3.576 2.237 0 3.715 1.436 3.715 3.59 0 2.182-1.493 3.591-3.757 3.591zm.014-5.165c-.87 0-1.491.65-1.491 1.56 0 .926.607 1.575 1.491 1.575.856 0 1.492-.663 1.492-1.56 0-.926-.622-1.575-1.492-1.575z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='ic_jio_dot_exclude_svg__clip0_7826_127526'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);
